import React from 'react';
import Slider from "react-slick";
import { slickDot } from "../utils/script";

const TestimonialData = [
    {
        form: "IEEE",
        description: "IEEE, an association dedicated to advancing innovation and technological excellence for the benefit of humanity, is the world’s largest technical professional society.",
        name: "Advancing Technology for Humanity",
        subtitle: "The Word's largest technical professional organization for the advancement of technology",
        image: "testimonial-IEEE"
    },
    {
        form: "IEEE Tunisia Section",
        description: "The IEEE Tunisia section, under the IEEE Region 8, is a non-profit organisation representing IEEE in Tunisia which was established on June 21,2007, It aims to spread IEEE Activities to all corners of the country by educational and technical activities, human networking,",
        name: "Tunisia Section",
        subtitle: "IEEE Region 8",
        image: "testimonial-IEEE-TNS"
    },
    {
        form: "IEEE ISSATSo",
        description: "IEEE ISSATSo SB was approuved by IEEE on the 4th of February 2015. At the begginning it was formed by 17 members. So far we are about 170 members now. Our targets are so diverse like Robotics, Automation, Energetic, Computer Science.. .",
        name: "IEEE ISSAT Sousse Student Branch",
        subtitle: "Come as Student, Leave as a Leader",
        image: "testimonial-IEEE-ISSATSo"
    },
    

]
const AboutTestamonial = ({teamStyle}) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <Slider className="slick-space-gutter--15 rn-slick-dot rn-slick-arrow mb--60" {...slickDot}>
                    {TestimonialData.map((data, index) => (
                        <div key={index} className={`testimonial-style-two ${teamStyle}`}>
                            <div className="row align-items-center row--20">
                                <div className="order-2 order-md-1 col-lg-6 col-md-8 offset-lg-1">
                                    <div className="content mt_sm--40">
                                        <span className="form">{data.form}</span>
                                        <p className="description">{data.description}</p>
                                        <div className="client-info">
                                            <h4 className="title">{data.name}</h4>
                                            <h6 className="subtitle">{data.subtitle}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-1 order-md-2 col-lg-4 col-md-4">
                                    <div className="thumbnail">
                                        <img className="w-100" src={`./images/testimonial/${data.image}.png`} alt="Testemonial" />
                                    </div>
                                </div>
                            </div> 
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}
export default AboutTestamonial;




















